import { BillingStatusDto } from '../generated'

export interface CheckoutSuccessNotice {
  title: string
  description: string
}

// What to tell an admin who comes back from Checkout to a club in good standing
export const checkoutSuccessNotice = (
  billing: BillingStatusDto
): CheckoutSuccessNotice | null => {
  switch (billing.subscriptionStatus) {
    case 'past_due':
      // No Checkout ends in past_due, so this is a stale link. The Billing tab
      // says that the payment failed
      return null
    case 'trialing':
      return {
        title: 'Your free trial has started',
        description:
          'Your club has full access for the next 90 days. Add a card before the trial ends to keep access - $19/month per club, cancel anytime from the billing page',
      }
    default:
      return {
        title: 'Subscription active',
        description:
          'Your club subscription is active. Manage it anytime from the billing page',
      }
  }
}
